import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Button, message, Space, Flex, Spin, Popconfirm } from "antd";
import List from "../../../Commons/BasicModule/List";
import { getCyclesRequest, getCyclesState } from "../../../Stores/CycleSlice";
import { changePassKeyRequest, deleteKeysRequest, renewKeyRequest, checkKeyRequest } from '../../../Stores/KeySlice';
import { CheckCircleTwoTone } from '@ant-design/icons';
import ModalExportAll from "./Components/Modal/ExportAll";
import ModalExportHTTP from "./Components/Modal/ExportHTTP";
import ModalExportSOCKS from "./Components/Modal/ExportSOCKS";
import ModalExportIP from "./Components/Modal/ExportIP";
import { getLangModule } from "../../../Stores/AuthSlice";
import ExtendKeyModal from "./Modal/ExtendKey";
import SelectMulti from "./Components/SelectMulti";
import { getUserByIDRequest } from "../../../Stores/UserSlice";
import ChangePasswdModal from "./Modal/ChangePasswd";
import FilterInfoModal from "./Components/Modal/FilterInfo";

// No Edit 
const tableField = ['id']
const columnTable = tableField.map((field) => ({
    title: field.replace(/_/g, ' ').toUpperCase(),
    dataIndex: field,
    key: field,
    render: (text, record) => {
        if (field === 'id') {
            return (
                <Button
                    type="link"
                    onClick={() => {
                        navigator.clipboard.writeText(text)
                        message.success('ID copied to clipboard')
                    }}
                >
                    {text}
                </Button>
            )
        }
        return text;
    }
}))

const customColumn = [...columnTable,
{
    title: 'Cycle Name',
    dataIndex: 'cycle_name',
    key: 'cycle_name',
    width: 260,
    onFilter: (value, record) => record.cycle_name === value,
    render: (record) => record
},
{
    title: 'Created At',
    dataIndex: 'created_at',
    key: 'created_at',
    sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
},
{
    title: 'End Date',
    dataIndex: 'end_date',
    key: 'end_date',
    sorter: (a, b) => new Date(a.end_date) - new Date(b.end_date),
}, {
    title: 'INFO',
    dataIndex: 'info',
    key: 'info',
    width: 210,
    render: (_, record) => {
        return <Flex wrap>
            <span>Username: <span className=" bg-slate-300 px-2 rounded-md">{record.username}</span></span>
            <span>Password: <span className=" bg-slate-300 px-2 rounded-md">{record.password}</span></span>
            <span>HTTP Port: <span className=" bg-slate-300 px-2 rounded-md">{record.port}</span></span>
            <span>SOCKS5 Port: <span className=" bg-slate-300 px-2 rounded-md">{record.socks5}</span></span>
        </Flex>
    }
}, {
    title: 'RENEW',
    dataIndex: 'auto_renew',
    key: 'auto_renew',
    width: 100,
    render: (record) => record ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CheckCircleTwoTone twoToneColor="#ccc" />
}, {
    title: 'SHARED',
    dataIndex: 'is_shared',
    key: 'is_shared',
    width: 100,
    render: (record) => record ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CheckCircleTwoTone twoToneColor="#ccc" />
}, {
    title: 'STATUS',
    dataIndex: 'status',
    key: 'status',
    width: 100,
    filters: [
        { text: 'Active', value: true },
        { text: 'Inactive', value: false },
    ],
    onFilter: (value, record) => record.status === value,
    render: (record) => record ? 'Active' : 'Inactive'
}]

const KeyComponent = ({ data }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const { id } = useParams();

    const langData = useSelector(getLangModule);
    const { key: lang } = langData;

    const cyclesData = useSelector(getCyclesState);
    const [dataTable, setDataTable] = useState([]);

    // Modal ExportAll 
    const [openModalExportAll, setOpenModalExportAll] = useState(false);
    const [openModalExportHTTP, setOpenModalExportHTTP] = useState(false);
    const [openModalExportSOCKS, setOpenModalExportSOCKS] = useState(false);
    const [openModalExportIP, setOpenModalExportIP] = useState(false);

    const [openModalChangePasswd, setOpenModalChangePasswd] = useState(false);
    const [openModalFilterInfo, setOpenModalFilterInfo] = useState(false);

    // Extend Pack Modal
    const [extendPackRecord, setExtendPackRecord] = useState({});
    const [isOpenExtendPack, setIsOpenExtendPack] = useState(false);
    const [searchData, setSearchData] = useState("");

    const [dataFilter, setDataFilter] = useState([])
    const [statusFillterData, setStatusFillterData] = useState([]);

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([])

    useEffect(() => {
        dispatch(getCyclesRequest());
    }, [])

    useEffect(() => {
        let keys = data.data.keys.map(key => ({ ...key }));
        if (cyclesData) {
            cyclesData.map(cycle => {
                keys.map(key => {
                    if (cycle.id == key.cycle_id) {
                        key.cycle_name = cycle.name
                    }
                })
            })
        }

        // Data for filter cycle
        const uniqueCycleNames = [...new Set(cyclesData.map(item => item.name))];
        const cycleNameFilters = uniqueCycleNames.map(name => ({
            text: name,
            value: name,
        }));
        customColumn[1].filters = cycleNameFilters

        setDataTable(keys)
        setDataFilter(keys)
    }, [cyclesData, data])

    useEffect(() => {
        // Filter
        let updatedKeyData = [...dataTable]
        // updatedKeyData = updatedKeyData.filter((key) =>
        //     cyclesFillterData.some(cycle => cycle.id == key.cycle_id)
        // )

        statusFillterData.map((filter) => {
            updatedKeyData = updatedKeyData.filter((key) => {
                if (key.status == filter.status) {
                    return true
                }
            })
        })
        updatedKeyData = updatedKeyData.filter((key) => {
            if (searchData && key.cycle_data) {
                if (key.cycle_data.name.indexOf(searchData) !== -1) {
                    return true
                }
                if (key.id.indexOf(searchData) !== -1) {
                    return true
                }
            }
            if (!searchData) {
                return true
            }
        })

        setDataFilter(updatedKeyData)
    }, [statusFillterData, searchData])

    const rowClassName = (record) => {
        return record.status === false ? 'bg-gray-200' : '';
    }
    const onExportAll = (e) => {
        setOpenModalExportAll(true)
    }

    const onExportHTTP = (e) => {
        setOpenModalExportHTTP(true)
    }
    const onExportSock = (e) => {
        setOpenModalExportSOCKS(true)
    }
    const onExportIP = (e) => {
        setOpenModalExportIP(true)
    }

    const onCheckKey = () => {
        if (selectedRows.length === 0) {
            message.warning(lang?.select_key_warning || "Vui lòng chọn ít nhất một key để kiểm tra");
            return;
        }

        setIsLoading(true);
        selectedRows.forEach(keyObj => {
            dispatch(checkKeyRequest(keyObj.id)).then((response) => {
                if (response.payload) {
                    // Refresh data after successful check
                    dispatch(getUserByIDRequest(id));
                }
                setIsLoading(false);
            });
        });
    };

    const onDelete = (id) => {
        // setIsLoading(true)
        dispatch(deleteKeysRequest(id)).then((response) => {
            // dispatch(getKeysRequest())
        });
    }

    const onExtendProxy = (record) => {
        setIsOpenExtendPack(true)
        setExtendPackRecord(record)
    }

    const onCloseExtendPack = () => {
        setIsOpenExtendPack(false)
    }

    const onChangeSearch = (e) => {
        setSearchData(e.target.value)
    }

    const rowSelection = {
        type: "checkbox",
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
            setSelectedRows(selectedRows)
        },
    };

    const onExtendMulti = () => {
        setIsLoading(true)
        // Loading on
        selectedRows.forEach(keyObj => {
            dispatch(renewKeyRequest({
                key_id: keyObj.id,
                cycle_id: keyObj.cycle_id,
                quantity: 1,
            })).then((response) => {
                setSelectedRowKeys([]);
                setSelectedRows([])
                dispatch(getUserByIDRequest(id))
                setIsLoading(false)
            });
        });
    }

    const onDeleteMulti = () => {
        setIsLoading(true)
        selectedRows.forEach(keyObj => {
            dispatch(deleteKeysRequest(keyObj.id)).then((response) => {
                setSelectedRowKeys([]);
                setSelectedRows([])
                dispatch(getUserByIDRequest(id))
                setIsLoading(false)
            });
        });
    }

    const onChangePasswd = () => {
        setOpenModalChangePasswd(!openModalChangePasswd)
    }

    const onChangePassMulti = (newPasswd) => {
        setIsLoading(true)
        selectedRows.forEach(keyObj => {
            dispatch(changePassKeyRequest({
                keyID: keyObj.id,
                newPasswd,
            })).then((response) => {
                setSelectedRowKeys([]);
                setSelectedRows([])
                dispatch(getUserByIDRequest(id))
                setIsLoading(false)
            });
        });
    }

    const onFilterInfoProxy = (data) => {
        if (data == -1) {
            setSearchData("1")
            setSearchData(0)
            setOpenModalFilterInfo(false)
            return;
        }
        const inputProxies = data
            .split("\n")
            .map(line => line.trim())
            .filter(line => line);

        const matched = dataTable.filter(item => {
            return inputProxies.some(inputProxy => {
                let inputUsername = null;
                let inputPassword = null;
                
                // Check if input contains colon (proxy format)
                if (inputProxy.includes(':')) {
                    // Format 1: user:pass@ip:port
                    if (inputProxy.includes('@')) {
                        const [userPass, ipPort] = inputProxy.split('@');
                        if (userPass.includes(':')) {
                            const userPassParts = userPass.split(':');
                            inputUsername = userPassParts[0];
                            inputPassword = userPassParts[1];
                        }
                    }
                    // Format 2: ip:port:user:pass
                    else {
                        const parts = inputProxy.split(':');
                        if (parts.length >= 4) {
                            // Extract username and password from input (positions 2 and 3)
                            inputUsername = parts[2];
                            inputPassword = parts[3];
                        }
                    }

                    // If we found username and password, compare them
                    if (inputUsername && inputPassword) {
                        return item.username === inputUsername && item.password === inputPassword;
                    }
                }

                // Check if input is a UUID format
                const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
                if (uuidRegex.test(inputProxy)) {

                    // Match UUID exactly
                    return item.id && item.id.toLowerCase() === inputProxy.toLowerCase();
                }

                // Check if input is a partial UUID (without dashes)
                const uuidWithoutDashes = /^[0-9a-f]{32}$/i;
                if (uuidWithoutDashes.test(inputProxy)) {
                    // Convert to UUID format and compare
                    const formattedUuid = inputProxy.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');
                    return item.id && item.id.toLowerCase() === formattedUuid.toLowerCase();
                }

                // Check for partial UUID match (contains the input)
                if (item.id && item.id.toLowerCase().includes(inputProxy.toLowerCase())) {
                    return true;
                }

                // Fallback: check if input matches username, password, or ID directly
                return item.username === inputProxy || 
                       item.password === inputProxy || 
                       (item.id && item.id.toString() === inputProxy);
            });
        });

        setDataFilter(matched);
        setOpenModalFilterInfo(false)
    }

    return <Card
        style={{
            marginTop: 4,
        }}
        type="inner"
        title="Key"
        loading={data.isLoading}
    >
        <Spin spinning={isLoading}>
            <div className="flex flex-wrap">
                <div className="relative p-2 w-60">
                    <input
                        className="bg-white w-full pl-3 py-2 bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md"
                        placeholder="Search for key..."
                        onChange={onChangeSearch}
                    />
                    <button
                        className="absolute h-8 w-8 right-3 top-3 my-auto px-2 flex items-center bg-white rounded "
                        type="button"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="3" stroke="currentColor" className="w-8 h-8 text-slate-600">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                        </svg>
                    </button>
                </div>
                <SelectMulti
                    placeholder={lang.status || "Tình trạng Key"}
                    options={[
                        { id: 1, name: "Còn hiệu lực", status: true },
                        { id: 2, name: "Hết hạn", status: false },
                    ]}
                    setData={setStatusFillterData}
                />
                <div className="relative p-2">
                    <Button style={{ height: "38px" }} onClick={() => setOpenModalFilterInfo(true)}>&#xe138; Filter Info</Button>
                </div>
                <div className="p-2 pr-8 flex justify-end flex-1">
                    <Button onClick={onExportIP} className="mr-2 inline-flex items-center gap-2 rounded-md bg-gray-700 py-1.5 px-3 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-gray-600 data-[open]:bg-gray-700 data-[focus]:outline-1 data-[focus]:outline-white">
                        {lang.export_ip || "Xuất IP"}
                    </Button>
                    <Button onClick={onExportHTTP} className="mr-2 inline-flex items-center gap-2 rounded-md bg-gray-700 py-1.5 px-3 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-gray-600 data-[open]:bg-gray-700 data-[focus]:outline-1 data-[focus]:outline-white">
                        {lang.export_http || "Xuất HTTP"}
                    </Button>
                    <Button onClick={onExportSock} className="mr-2 inline-flex items-center gap-2 rounded-md bg-gray-700 py-1.5 px-3 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-gray-600 data-[open]:bg-gray-700 data-[focus]:outline-1 data-[focus]:outline-white">
                        {lang.export_socks || "Xuất SOCKS5"}
                    </Button>
                    <Button onClick={onExportAll} className="inline-flex items-center gap-2 rounded-md bg-gray-700 py-1.5 px-3 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-gray-600 data-[open]:bg-gray-700 data-[focus]:outline-1 data-[focus]:outline-white">
                        {lang.export_all || "Xuất KEY"}
                    </Button>
                </div>
                {rowSelection ? <div className="w-full flex items-center mb-3 mt-1 pl-3 h-4">
                    Selected: {selectedRows.length} {selectedRows.length > 0 ? "Items" : ""} || <> </>
                    {selectedRows.length ? <Space style={{ marginLeft: '10px' }}>
                        <Popconfirm
                            title="Confirm"
                            description="Are you sure?"
                            onConfirm={onExtendMulti}
                        >
                            <Button
                                key={1}
                                style={{ color: "green", borderColor: "green", marginRight: '8px' }}
                            // onClick={onExtendMulti}
                            >
                                Extend
                            </Button>
                        </Popconfirm>

                        <Popconfirm
                            title="Confirm"
                            description="Are you sure?"
                            onConfirm={onDeleteMulti}
                        >
                            <Button
                                key={2}
                                style={{ color: "red", borderColor: "red", marginRight: '8px' }}
                            // onClick={onDeleteMulti}
                            >
                                Delete
                            </Button>
                        </Popconfirm>

                        <Button
                            key={3}
                            style={{ color: "blue", borderColor: "blue", marginRight: '8px' }}
                            onClick={onChangePasswd}
                        >
                            Change Password
                        </Button>
                        <Button onClick={onCheckKey} className="mr-2 inline-flex items-center gap-2 rounded-md bg-blue-600 py-1.5 px-3 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-blue-500 data-[open]:bg-blue-700 data-[focus]:outline-1 data-[focus]:outline-white">
                            {lang.check_key || "Check KEY"}
                        </Button>
                    </Space> : ""}
                </div> : ""}
            </div>
            <List
                columnTable={customColumn}
                dataList={dataFilter}
                rowClassName={rowClassName}
                onDeleteEvent={onDelete}
                onExtendProxy={onExtendProxy}
                rowSelection={rowSelection}
            />
        </Spin>
        <ModalExportAll
            isOpen={openModalExportAll}
            setIsOpen={setOpenModalExportAll}
            keyData={dataFilter}
            selected={selectedRows}
        />
        <ModalExportHTTP
            isOpen={openModalExportHTTP}
            setIsOpen={setOpenModalExportHTTP}
            data={dataFilter}
            lang={lang}
            selected={selectedRows}
        />
        <ModalExportSOCKS
            isOpen={openModalExportSOCKS}
            setIsOpen={setOpenModalExportSOCKS}
            data={dataFilter}
            lang={lang}
            selected={selectedRows}
        />
        <ModalExportIP
            isOpen={openModalExportIP}
            setIsOpen={setOpenModalExportIP}
            data={dataFilter}
            lang={lang}
            selected={selectedRows}
        />

        <ExtendKeyModal
            isOpen={isOpenExtendPack}
            onClose={onCloseExtendPack}
            record={extendPackRecord}
        />

        <ChangePasswdModal
            isOpen={openModalChangePasswd}
            onClose={onChangePasswd}
            onUpdate={onChangePassMulti}
        />

        <FilterInfoModal
            isOpen={openModalFilterInfo}
            handleCancel={() => setOpenModalFilterInfo(false)}
            onSearch={onFilterInfoProxy}
        />
    </Card>
}

export default KeyComponent